"use client";

import { MapPin } from 'lucide-react';
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
export default function Contact() {
  const reduce = useReducedMotion();
  const headerVariants = {
    hidden: {
      opacity: 0,
      y: reduce ? 0 : 16
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.52,
        ease: [0.2, 0.6, 0.2, 1] as const
      }
    }
  };
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: reduce ? 0 : 0.09,
        delayChildren: 0.1
      }
    }
  };
  return <section data-section-id="32627" id="ubicacion" data-nav="light" className="relative border-t border-border bg-background" style={{
    paddingTop: "clamp(5rem, 9vw, 9rem)",
    paddingBottom: "clamp(5rem, 9vw, 9rem)"
  }}>
      <div className="mx-auto w-full" style={{
      maxWidth: "1360px",
      paddingLeft: "clamp(1.25rem, 4vw, 3rem)",
      paddingRight: "clamp(1.25rem, 4vw, 3rem)"
    }}>
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.3
      }} className="mx-auto flex flex-col items-center text-center" style={{
        marginBottom: "clamp(2.5rem, 4vw, 3.5rem)"
      }}>
          <motion.div variants={headerVariants} className="flex items-center gap-3">
            <span aria-hidden="true" className="inline-block" style={{
            width: "1.5px",
            height: "12px",
            backgroundColor: "var(--primary)"
          }} />
            <span className="font-default font-semibold uppercase text-primary" style={{
            fontSize: "0.75rem",
            letterSpacing: "0.22em",
            lineHeight: 1
          }}>
              Ubicación
            </span>
            <span aria-hidden="true" className="inline-block" style={{
            width: "1.5px",
            height: "12px",
            backgroundColor: "var(--primary)"
          }} />
          </motion.div>

          <motion.h2 variants={headerVariants} className="mt-6 font-default font-bold uppercase text-foreground" style={{
          fontSize: "clamp(2.25rem, 5vw, 4.5rem)",
          letterSpacing: "-0.005em",
          lineHeight: 0.98,
          maxWidth: "22ch",
          fontStretch: "condensed"
        }}>
            Dónde estamos
          </motion.h2>

          <motion.p variants={headerVariants} className="mt-4 font-default text-muted-foreground" style={{
          fontSize: "clamp(1rem, 1.25vw, 1.25rem)",
          lineHeight: 1.6,
          maxWidth: "40ch"
        }}>
            Oficina central: La Vía Nueva 69, Totana, Murcia.
          </motion.p>
        </motion.div>
      </div>

      <motion.div variants={headerVariants} initial="hidden" whileInView="show" viewport={{
      once: true,
      amount: 0.2
    }} className="w-full border-y border-border bg-card shadow-sm">
        <iframe src="https://maps.google.com/maps?q=La+V%C3%ADa+Nueva+69,+Totana,+Murcia&t=&z=15&ie=UTF8&iwloc=&output=embed" title="Ubicación de Servicios de reparaciones en Totana, Murcia" loading="lazy" className="w-full h-[380px] md:h-[480px] border-0" allowFullScreen />
      </motion.div>

      <div className="mx-auto w-full mt-6" style={{
      maxWidth: "1360px",
      paddingLeft: "clamp(1.25rem, 4vw, 3rem)",
      paddingRight: "clamp(1.25rem, 4vw, 3rem)"
    }}>
        <motion.div variants={headerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.5
      }} className="flex items-center justify-center">
          <Link to="https://www.google.com/maps/search/?api=1&query=La+V%C3%ADa+Nueva+69,+Totana,+Murcia" newTab className="inline-flex items-center gap-2 font-default text-sm font-semibold uppercase tracking-wider text-primary transition-colors duration-200 hover:text-primary/80">
            <MapPin className="size-4" />
            <span>Cómo llegar</span>
          </Link>
        </motion.div>
      </div>
    </section>;
}